import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function select(theme: Theme): ComponentStyle {
  return {
    componentName: 'select',
    baseStyle: {
      backgroundColor: theme.colors.black23,
      color: theme.colors.text,
      fontSize: theme.sizes['0'],
      padding: [
        `${theme.space.s} ${theme.space.s} ${theme.space.s} ${theme.space['s']}`,
        `${theme.space.xs} ${theme.space.xs} ${theme.space.xs} ${theme.space['2xs']}`
      ],

      '&:hover': {
        backgroundColor: theme.colors.linkHover
      }
    },
    variants: {}
  };
}
